<template>
  <div class="flv-player-wrapper"></div>
</template>

<script>
import DPlayer from 'dplayer'
// import axios from 'axios'

export default {
  name: 'flv-player2',

  data () {
    return {
      currentUrl: ''
    }
  },

  props: {
    videoUrl: String
  },

  watch: {
    videoUrl (v) {
      // 播放地址变化（如切换车辆）时重建播放器，避免沿用旧连接
      if (v && v !== this.currentUrl) {
        this.init()
      }
    }
  },

  methods: {
    init () {
      if (this.player) {
        this.player.destroy()
        this.player = null
      }
      if (!this.videoUrl) {
        return
      }
      this.currentUrl = this.videoUrl
      /* eslint-disable no-new */
      this.player = new DPlayer({
        container: this.$el,
        screenshot: true,
        // 实时流按直播处理：不套用点播的时间轴与缓冲策略
        live: true,
        mutex: false,
        video: {
          pic: '/img/videoDefault.png',
          url: this.videoUrl,
          type: 'flv'
        },
        // DPlayer 会把 pluginOptions.flv 透传给 flv.js
        pluginOptions: {
          hls: {},
          dash: {},
          webtorrent: {},
          flv: {
            mediaDataSource: {
              isLive: true,
              hasAudio: false,
              hasVideo: true,
              cors: true
            },
            // 直播场景收紧攒束缓冲，降低起播等待与累计延迟
            config: {
              enableStashBuffer: false,
              stashInitialSize: 128,
              lazyLoad: false,
              autoCleanupSourceBuffer: true
            }
          }
        }
      })
      this.player.play()
    }
  },

  mounted () {
    this.$nextTick(() => {
      this.init()
    })
  },

  beforeDestroy () {
    if (this.player) {
      this.player.destroy()
      this.player = null
    }
  }

}
</script>

<style lang="scss">
.flv-player-wrapper {
  width: 100%;
  height: 100%;
  .dplayer-video {
    object-fit: fill;
  }
  .dplayer-volume, .dplayer-time, .dplayer-setting {
    display: none!important;
  }
}
</style>
